import { render } from "./WebphoneExtension.vue?vue&type=template&id=1563d337&scoped=true"
import script from "./WebphoneExtension.vue?vue&type=script&lang=js"
export * from "./WebphoneExtension.vue?vue&type=script&lang=js"

import "./WebphoneExtension.vue?vue&type=style&index=0&id=1563d337&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1563d337"]])

export default __exports__